<template>
  <div v-if="ajaxLoaded" class="pumpReport-ctn" :style="style">
    <template>
      <a4-horizontal v-for="(one, i) in calculatorSettingPages" :key="`dailygraph_setting_p_${+new Date()}_${i}`" class="largerA4" is-pump no-title :no-flex-grow="true" :first-row-no-margin-top="true" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList">
        <template slot="firstRow">
          <div>
            <div class="tips" :style="{ zoom: zoomRatio, marginTop: 0, marginBottom: Math.floor(zoomRatio * 20) + 'px' }">
              <div class="border"></div>
              <div class="label">{{ $t('Insulin Usage Statistics') }}</div>
            </div>
            <div class="insulinUsageChartCtn">
              <insulin-usage-statistics-table1 :extra="insulinUsageStatisticsObj" :carbs="daysCarbsTotal" :carbs-valid-days="carbsValidDays" />
              <chart-pie :values="pie1arr" />
            </div>
            <div class="tips" :style="{ zoom: zoomRatio, marginTop: 0, marginBottom: Math.floor(zoomRatio * 20) + 'px' }">
              <div class="border"></div>
              <div class="label">{{ $t('Bolus Calculator Setting') }}</div>
            </div>
            <div class="insulinUsageChartCtn">
              <insulin-delivery-setting-table :list="insulinDeliverySetting3Columns" :row-nums="4" :width="512 * 1.8" size2 />
              <!-- <insulin-usage-statistics-table2 :extra="insulinUsageStatisticsObj" :carbs="daysCarbsTotal" :carbsValidDays="carbsValidDays" /> -->
              <!-- <chart-pie :values="pie2arr" :colors="['rgba(73, 205, 133, 1)', 'rgba(200, 240, 218, 1)']" t1="Insulin Usage Per Day" /> -->
            </div>
          </div>
          <div :style="{ flex: 1, marginLeft: isLongLanguage ? (zoomRatio * 2 + 'rem') : (Math.floor(zoomRatio * 50) + 'px') }">
            <div class="tips" :style="{ zoom: zoomRatio, marginTop: 0, marginBottom: Math.floor(zoomRatio * 20) + 'px' }">
              <div class="border"></div>
              <div class="label">{{ $t('BGM & CGMs Statistics') }}</div>
            </div>
            <div class="eventTablesCtn-row">
              <div class="eventTablesCtnRow-tables">
                <bG-event-table high high-total="30" :values="bgmEventTableHighData" what="BGM" />
                <bG-event-table :high="false" low low-total="40" :values="bgmEventTableLowData" what="BGM" />
              </div>              
              <div>
                <chart-bar-v2 size-ratio3 :show-margin-right="false" :rect-nums="barRectNums" :true-counts="multiDayBarTrueCounts" :true-percents="multiDayBarTruePercents" :title="$t('% BGM Reading in target')" />
              </div>
            </div>
            <div class="eventTablesCtn-row">
              <div class="eventTablesCtnRow-tables">
                <cgm-core-param-table :cgm-record="agpData" />
              </div>              
              <div>
                <chart-bar-v2 size-ratio3 :show-margin-right="false" :rect-nums="barRectNums" :true-counts="multiDayCGMBarTrueCounts" :true-percents="multiDayCGMBarTruePercents" :title="$t('% CGM Reading in target')" />
              </div>
            </div>
            <div class="eventTablesCtn-row eventTablesCtn-row--w100">
              <div class="eventTablesCtnRow-tables">
                <cgm-agp :cgm-record="agpData" />
              </div>
            </div>
            <!-- <div class="eventTablesCtn"> -->
            <!--   <div class="eventTablesCtn-row"> -->
            <!--     <bG-event-table high highTotal="30" :values="cgmEventTableHighData" /> -->
            <!--     <bG-event-table :high="false" low lowTotal="40" :values="cgmEventTableLowData" /> -->
            <!--   </div> -->
            <!--   <div class="eventTablesCtn-row"> -->
            <!--     <bG-event-table high highTotal="30" :values="bgmEventTableHighData" what="BGM" /> -->
            <!--     <bG-event-table :high="false" low lowTotal="40" :values="bgmEventTableLowData" what="BGM" /> -->
            <!--   </div> -->
            <!--  </div> -->
            <!-- <div class="insulinUsageChartCtn"> -->
            <!--   <chart-bar-v2 size-ratio2 :show-margin-right="false" :rect-nums="barRectNums" :true-counts="multiDayBarTrueCounts" :true-percents="multiDayBarTruePercents" :title="$t('% BGM Reading in target')" /> -->
            <!--   <chart-bar-v2 size-ratio2 :show-margin-right="false" :rect-nums="barRectNums" :true-counts="multiDayCGMBarTrueCounts" :true-percents="multiDayCGMBarTruePercents" :title="$t('% CGM Reading in target')" /> -->
            <!-- </div> -->
          </div>
        </template>
        <template slot="secondRow">
        </template>
      </a4-horizontal>      
    </template>
    <template>
      <a4-horizontal v-for="(one, i) in calculatorSettingPages" :key="`dailygraph_setting_p_${+new Date()}_${i}`" class="largerA4" is-pump no-title :no-flex-grow="true" :first-row-no-margin-top="true" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList">
        <template slot="firstRow">
          <div>
            <div class="tips" :style="{ zoom: zoomRatio, marginTop: 0, marginBottom: Math.floor(zoomRatio * 20) + 'px' }">
              <div class="border"></div>
              <div class="label">{{ $t('Bolus Calculator Setting') }}</div>
            </div>
            <bolus-calculator-setting-table-v3 :carbo-list="one['carboList']" :sensitivity-list="one['sensitivityList']" :bg-list="one['bgList']" :extra="one['extra']" :carbo-row-nums="one['carboRowNums']" :bg-row-nums="one['bgRowNums']" :sensitivity-row-nums="one['sensitivityRowNums']" />
          </div>
          <div :style="{ marginLeft: Math.floor(zoomRatio * 50) + 'px' }">
            <div class="tips" :style="{ zoom: zoomRatio, marginTop: 0, marginBottom: Math.floor(zoomRatio * 20) + 'px' }">
              <div class="border"></div>
              <div class="label">{{ $t('Active Basal') }}</div>
            </div>
            <basals-table-v2 :settings="basalRateBaseSetting" />
            <!-- <div class="tips" :style="{ zoom: zoomRatio, marginTop: 0, marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 20) + 'px' }"> -->
            <!--   <div class="border"></div> -->
            <!--   <div class="label">{{ $t('Insulin Delivery Setting') }}</div> -->
            <!-- </div> -->
            <!-- <insulin-delivery-setting-table :list="insulinDeliverySetting3Columns" :row-nums="4" :width="512 * 1.8" size2 /> -->
            <!-- <pump-two-column-table :row-nums="11" :list="insulinDeliverySetting"/> -->
          </div>
        </template>
        <template slot="secondRow">
        </template>
      </a4-horizontal>
    </template>
    <a4-horizontal v-if="showActiveBasalPage && basalRateBaseSetting && basalRateBaseSetting.length > 7" is-pump :title="$t('Active Basal')" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :no-flex-grow="true">
      <template slot="firstRow">
        <div>
          <basals-table-v2 :settings="basalRateBaseSetting" :first7patch="false" />
        </div>
      </template>
      <template slot="secondRow">
      </template>
    </a4-horizontal>
    <template v-if="showMultiDayPumpGraphPage">
      <a4-horizontal v-for="(page, i) in multiDayPumpGraphPages" :key="`dailygraph_pump_${i}_p_${+new Date()}`" is-pump :title="$t('Multi-day Pump Graph')" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :no-flex-grow="true">
        <template slot="firstRow">
          <chart-multi-daily-pump :values="page['list']" :warnings="warmMsg" :all-deadline-gaps="allDeadlineGaps" :basal-rate-info-msg="allBasalRateInfoMsges" :setting="setting" :no-meal-highlight="!showMealTimeHighlight" :no-horizontal-split-line="!showHorizontalSplitLine" :upload-events="dataUploadHis" :basal-rate-base-setting="basalRateBaseSetting" :quick-pump-tag-list="quickPumpTagList">
            <template slot="chartBar">
              <!-- <chart-bar dont-ratio size-ratio2 :rect-nums="barRectNums" :true-percents="multiDayBarTruePercents" :title="assessmentTimeWithoutDays" /> -->
              <chart-bar dont-ratio size-ratio2 :show-margin-right="false" :rect-nums="barRectNums" :true-percents="page['truePercents']" :true-counts="page['trueCounts']" :title="$t('% BGM Reading in target')" />
            </template>
          </chart-multi-daily-pump>
        </template>
      </a4-horizontal>
    </template>
    <template v-for="one in pumpLegalDailyList">
      <a4-horizontal v-if="showDailyGraphPumpPage && one && !one.bolusDetailFullPage" :key="`dailygraph_pump_p2_${+new Date()}_${one.date}`" :class="{ 'largerA4': true }" is-pump :title="$t('Daily Graph')" :atime="one.date" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :no-flex-grow="true">
        <template slot="firstRow">
          <div>
            <chart-daily-pump :value="one" :all-deadline-gaps="allDeadlineGaps" :yesterday="helperGetYesterdayOtherData(allDailyListWithFake, one.date, true)" :warnings="warmMsg" :basal-rate-info-msg="basalRateInfoMsg" :basal-rate-base-setting="basalRateBaseSetting" :quick-pump-tag-list="quickPumpTagList" :upload-events="dataUploadHis" />
            <div class="legends">
              <div class="legend chartDailyPumpLegend twoParts">
                <div class="legendsPart legendsPart--1">
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="circle-highcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('AiDEX High BG')}} -->
                  <!-- </wt-legend> -->
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="circle-normalcolor" /> -->
                  <!--   </template> -->
                  <!--   {{ $t('AiDEX Normal BG') }} -->
                  <!-- </wt-legend> -->
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="circle-lowcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('AiDEX Low BG')}} -->
                  <!-- </wt-legend> -->      
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="triangle-highcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('CGMs High BG')}} -->
                  <!-- </wt-legend> -->
                  <wt-legend>
                    <template slot="icon">
                      <svg-icon icon-class="triangle-normalcolor" />
                    </template>
                    {{ $t('CGMs Normal BG') }}
                  </wt-legend>
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="triangle-lowcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('CGMs Low BG')}} -->
                  <!-- </wt-legend> -->
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="rect-highcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('Pump High BG')}} -->
                  <!-- </wt-legend> -->
                  <wt-legend>
                    <template slot="icon">
                      <svg-icon icon-class="rect-normalcolor" />
                    </template>
                    {{ $t('Pump Normal BG') }}
                  </wt-legend>
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="rect-lowcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('Pump Low BG')}} -->
                  <!-- </wt-legend> -->
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="diamond-highcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('BG High BG')}} -->
                  <!-- </wt-legend> -->
                  <wt-legend>
                    <template slot="icon">
                      <svg-icon icon-class="diamond-normalcolor" />
                    </template>
                    {{ $t('BG Normal BG') }}
                  </wt-legend>
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="diamond-lowcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('BG Low BG')}} -->
                  <!-- </wt-legend> -->
                </div>
                <div class="legendsPart legendsPart--2">
                  <div class="legendsPart--title">
                    {{ $t('Event Marker') }}
                  </div>
                  <wt-legend>
                    <template slot="icon">
                      <svg-icon icon-class="drug" />
                    </template>
                    {{ $t('Medicine') }}
                  </wt-legend>
                  <wt-legend>
                    <template slot="icon">
                      <svg-icon icon-class="apple" />
                    </template>
                    {{ $t('Carbs') }}
                  </wt-legend>
                  <wt-legend>
                    <template slot="icon">
                      <svg-icon icon-class="needle" />
                    </template>
                    {{ $t('Insulin') }}
                  </wt-legend>
                  <wt-legend>
                    <template slot="icon">
                      <svg-icon icon-class="sport" />
                    </template>
                    {{ $t('Exercise') }}
                  </wt-legend>
                </div>
              </div>
              <div class="legend chartDailyPumpLegend">
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-basalrate" />
                  </template>
                  {{ $t('Basal Rate') }}
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-bolus" />
                  </template>
                  {{ $t('Normal Bolus') }}({{ $t('Normal Bolus Abbreviation') }})
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-extendedbolus" />
                  </template>
                  {{ $t('Extended Bolus') }}({{ $t('Extended Bolus Abbreviation') }})
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-dual" />
                  </template>
                  {{ $t('Dual Wave') }}({{ $t('Dual Wave Abbreviation') }})
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="zebra-3" />
                  </template>
                  {{ $t('Temporary Basal Rate') }}
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-stopline" />
                  </template>
                  {{ $t('Stop Line') }}
                </wt-legend>      
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-alarm3" />
                  </template>
                  {{ $t('Alarm') }}
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-clock" />
                  </template>
                  {{ $t('Time Change') }}
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-needle" />
                  </template>
                  {{ $t('Quick Bolus') }}({{ $t('Quick Bolus Abbreviation') }})                  
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-upload2" />
                  </template>
                  {{ $t('Upload') }}
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-resovior3" />
                  </template>
                  {{ $t('Reservoir') }}
                </wt-legend>          
                <wt-legend v-for="(change, j) in moduleLegendsHelper(one)" :key="`wtlegend_changemodule_${j}`">
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-changemodule" />
                    <span :style="{ position: 'absolute', top: '0.4em', fontSize: '0.6em', left: ((change && change.order >= 10) ? '0.21em' : '0.43em') }">{{ change ? change.order : '' }}</span>
                  </template>
                  {{ changeFromI18n(change) }}
                </wt-legend>
              </div>
            </div>            
          </div>
        </template>
        <template slot="secondRow">          
          <div class="secondRow--tables">
            <div style="margin: 0 0.5rem;" :style="{ zoom: isLongLanguage ? 0.81 : 0.8243}">
              <table-bG-mesurement :value="helperGetDailyMesurement(one)" :width="bgMesurementWidth" :is-daily="true" :daily-total="NumberOfBgMeasurements.bgTotal" :carbon-total="NumberOfBgMeasurements.carbohydrTotal" h82 />
            </div>
            <!-- <div :style="barCtnStyle"> -->
            <!--   <chart-bar :rect-nums="barRectNums" :true-counts="dailyBehaviorHelperGetBarCountsData(one)" :true-percents="dailyBehaviorHelperGetBarData(one)" :title="one.date" size-ratio3 /> -->
            <!--   <chart-bar :rect-nums="barRectNums" :true-counts="multiDayBarTrueCounts" :true-percents="multiDayBarTruePercents" :title="assessmentTimeWithoutDays" size-ratio3 /> -->
            <!-- </div> -->
          </div>
          <pump-bolus-detail-table style="flex-shrink: 0;" :value="one" :calculators="calculatorList" :other-data="otherData" :quick-pump-tag-list="quickPumpTagList" :show-margin-right="false" :full-page-table="false" :is-long-lang="isLongLanguage" />
        </template>
      </a4-horizontal>
      <a4-horizontal v-if="showDailyGraphPumpPage && one && one.bolusDetailFullPage" :key="`dailygraph_pump_p2_bolusDetail_${one.bolusDetailFullPage}_${+new Date()}_${one.date}`" class="largerA4" is-pump :title="$t('Daily Graph')" :atime="one.date" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :no-flex-grow="true">
        <template slot="firstRow">          
          <pump-bolus-detail-table style="flex-shrink: 0;" :value="one" :calculators="calculatorList" :other-data="otherData" :quick-pump-tag-list="quickPumpTagList" :show-margin-right="false" :full-page-table="true" :is-long-lang="isLongLanguage" />
        </template>
        <template slot="secondRow">        
        </template>
      </a4-horizontal>
    </template>    
    <a4-horizontal v-if="showActiveBasalPage && false" is-pump :title="$t('Active Basal')" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :no-flex-grow="true">
      <template slot="firstRow">
        <div>
          <chart-pump-basal :value="activeBasalRateBase" />
          <div class="legend chartDailyPumpLegend">
            <wt-legend>
              <template slot="icon">
                <svg-icon icon-class="pumpicon-basalrate" />
              </template>
              {{ $t('Basal Rate') }}
            </wt-legend>
          </div>
        </div>
      </template>
      <template slot="secondRow">
        <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;">
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{ $t(basalRateBase1Name) }}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{ $t('Total Dose') }}: {{ basalRateBase1TotalDose }}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase1TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase1TableDataLarger4Columns" size2 :list="basalRateBase1TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase1TableDataLarger6Columns" size2 :list="basalRateBase1TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase1TableDataLarger8Columns" size2 :list="basalRateBase1TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase1TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{ $t(basalRateBase2Name) }}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{ $t('Total Dose') }}: {{ basalRateBase2TotalDose }}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase2TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase2TableDataLarger4Columns" size2 :list="basalRateBase2TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase2TableDataLarger6Columns" size2 :list="basalRateBase2TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase2TableDataLarger8Columns" size2 :list="basalRateBase2TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase2TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{ $t(basalRateBase3Name) }}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{ $t('Total Dose') }}: {{ basalRateBase3TotalDose }}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase3TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase3TableDataLarger4Columns" size2 :list="basalRateBase3TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase3TableDataLarger6Columns" size2 :list="basalRateBase3TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase3TableDataLarger8Columns" size2 :list="basalRateBase3TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase3TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>
        </div>
      </template>
    </a4-horizontal>
    <a4-horizontal v-if="showActiveBasalPage2 && false" is-pump :title="$t('Active Basal')" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :no-flex-grow="true">      
      <template slot="firstRow">
        <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;">
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{ $t(basalRateBase4Name) }}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{ $t('Total Dose') }}: {{ basalRateBase4TotalDose }}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase4TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase4TableDataLarger4Columns" size2 :list="basalRateBase4TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase4TableDataLarger6Columns" size2 :list="basalRateBase4TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase4TableDataLarger8Columns" size2 :list="basalRateBase4TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase4TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{ $t(basalRateBase5Name) }}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{ $t('Total Dose') }}: {{ basalRateBase5TotalDose }}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase5TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase5TableDataLarger4Columns" size2 :list="basalRateBase5TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase5TableDataLarger6Columns" size2 :list="basalRateBase5TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase5TableDataLarger8Columns" size2 :list="basalRateBase5TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase5TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{ $t(basalRateBase6Name) }}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{ $t('Total Dose') }}: {{ basalRateBase6TotalDose }}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase6TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase6TableDataLarger4Columns" size2 :list="basalRateBase6TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase6TableDataLarger6Columns" size2 :list="basalRateBase6TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase6TableDataLarger8Columns" size2 :list="basalRateBase6TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase6TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>
        </div>
      </template>
      <template slot="secondRow">
        <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;">
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{ $t(basalRateBase7Name) }}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{ $t('Total Dose') }}: {{ basalRateBase7TotalDose }}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase7TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase7TableDataLarger4Columns" size2 :list="basalRateBase7TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase7TableDataLarger6Columns" size2 :list="basalRateBase7TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase7TableDataLarger8Columns" size2 :list="basalRateBase7TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase7TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>          
        </div>
      </template>
    </a4-horizontal>
    <template v-if="showBolusCalculatorPage && false">
      <a4-horizontal v-for="(one, i) in calculatorSettingPages" :key="`dailygraph_setting_p_${+new Date()}_${i}`" is-pump no-title :no-flex-grow="true" :first-row-no-margin-top="false" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList">
        <template slot="firstRow">
          <div>
            <div class="tips" :style="{ zoom: zoomRatio, marginTop: 0, marginBottom: Math.floor(zoomRatio * 20) + 'px' }">
              <div class="border"></div>
              <div class="label">{{ $t('Bolus Calculator Setting') }}</div>
            </div>
            <bolus-calculator-setting-table :not-first-table="i !== 0" :carbo-list="one['carboList']" :sensitivity-list="one['sensitivityList']" :bg-list="one['bgList']" :extra="one['extra']" :carbo-row-nums="one['carboRowNums']" :bg-row-nums="one['bgRowNums']" :sensitivity-row-nums="one['sensitivityRowNums']" />
          </div>
          <div :style="{ marginRight: Math.floor(zoomRatio * 50) + 'px', opacity: (i === 0 ? '1' : '0') }">
            <div class="tips" :style="{ zoom: zoomRatio, marginTop: 0, marginBottom: Math.floor(zoomRatio * 20) + 'px' }">
              <div class="border"></div>
              <div class="label">{{ $t('Insulin Delivery Setting') }}</div>
            </div>
            <pump-two-column-table :row-nums="11" :list="insulinDeliverySetting" />
          </div>
        </template>
        <template slot="secondRow">
        </template>
      </a4-horizontal>
    </template>
    <template v-if="showAlarmRecordPage">
      <a4-horizontal v-for="(one, oneI) in alarmRecordPages" :key="`dailygraph_alarm_daily_p1_${+new Date()}_${one.date}_${oneI}`" is-pump is-grid :title="$t('Alarm Record')" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :first-row-no-margin-top="true">
        <template slot="firstRow">
          <div :style="{ width: '100%' }">            
            <div class="alarmRecord-oneRow">
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[0]['date'] | formatTime(getLocaleDateFormat('YYYY/MM/DD')) }}</div>
                <pump-two-column-table :row-nums="one[0]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[0]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[1]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[1]['date'] | formatTime(getLocaleDateFormat('YYYY/MM/DD')) }}</div>
                <pump-two-column-table :row-nums="one[1]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[1]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[2]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[2]['date'] | formatTime(getLocaleDateFormat('YYYY/MM/DD')) }}</div>
                <pump-two-column-table :row-nums="one[2]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[2]['list'])" :width="496" />
              </div>                         
            </div>
          </div>
        </template>
        <template slot="secondRow">
          <div :style="{ width: '100%' }">            
            <div class="alarmRecord-oneRow">
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[3]['isEmpty'] ? '0' : '1', fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[3]['date'] | formatTime(getLocaleDateFormat('YYYY/MM/DD')) }}</div>
                <pump-two-column-table :row-nums="one[3]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[3]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[4]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[4]['date'] | formatTime(getLocaleDateFormat('YYYY/MM/DD')) }}</div>
                <pump-two-column-table :row-nums="one[4]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[4]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[5]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[5]['date'] | formatTime(getLocaleDateFormat('YYYY/MM/DD')) }}</div>
                <pump-two-column-table :row-nums="one[5]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[5]['list'])" :width="496" />
              </div>                         
            </div>
          </div>
        </template>
      </a4-horizontal>
    </template>
    <template v-if="showTimeChangeRecordPage">
      <a4-horizontal v-for="(one, oneI) in timeChangeRecordPages" :key="`dailygraph_tchange_daily_p1_${+new Date()}_${one.date}_${oneI}`" is-pump is-grid :title="$t('Time Change')" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :first-row-no-margin-top="true">
        <template slot="firstRow">
          <div :style="{ width: '100%' }">            
            <div class="alarmRecord-oneRow">
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[0]['date'] | formatTime(getLocaleDateFormat('YYYY/MM/DD')) }}</div>
                <pump-two-column-table :row-nums="one[0]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[0]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[1]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[1]['date'] | formatTime(getLocaleDateFormat('YYYY/MM/DD')) }}</div>
                <pump-two-column-table :row-nums="one[1]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[1]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[2]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[2]['date'] | formatTime(getLocaleDateFormat('YYYY/MM/DD')) }}</div>
                <pump-two-column-table :row-nums="one[2]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[2]['list'])" :width="496" />
              </div>                         
            </div>
          </div>
        </template>
        <template slot="secondRow">
          <div :style="{ width: '100%' }">            
            <div class="alarmRecord-oneRow">
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[3]['isEmpty'] ? '0' : '1', fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[3]['date'] | formatTime(getLocaleDateFormat('YYYY/MM/DD')) }}</div>
                <pump-two-column-table :row-nums="one[3]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[3]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[4]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[4]['date'] | formatTime(getLocaleDateFormat('YYYY/MM/DD')) }}</div>
                <pump-two-column-table :row-nums="one[4]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[4]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[5]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[5]['date'] | formatTime(getLocaleDateFormat('YYYY/MM/DD')) }}</div>
                <pump-two-column-table :row-nums="one[5]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[5]['list'])" :width="496" />
              </div>                         
            </div>
          </div>
        </template>
      </a4-horizontal>
    </template>    
  </div>
  <div v-else class="pumpReport-ctn" :style="style">
  </div>
</template>
<script>
import A4Horizontal from '@c/A4Horizontal'
import wtLegend from '@c/Legend'
import ChartMultiDailyPump from '@c/ChartMultiDailyPump'
import ChartDailyPump from '@c/ChartDailyPump'
import ChartPumpBasal from '@c/ChartPumpBasal'
import PumpTwoColumnTable from '@c/PumpTwoColumnTable'
import Pump4ColumnTable from '@c/Pump4ColumnTable'
import Pump6ColumnTable from '@c/Pump6ColumnTable'
import Pump8ColumnTable from '@c/Pump8ColumnTable'
import BolusCalculatorSettingTable from '@c/BolusCalculatorSettingTable'
import BolusCalculatorSettingTableV3 from '@c/BolusCalculatorSettingTableV3'
// import InsulinUsageStatisticsTable from '@c/InsulinUsageStatisticsTable'
import InsulinUsageStatisticsTable1 from '@c/InsulinUsageStatisticsTable1'
// import InsulinUsageStatisticsTable2 from '@c/InsulinUsageStatisticsTable2'
import ChartPie from '@c/ChartPieV2'
import ChartBarV2 from '@c/ChartBarV2'
import BGEventTable from '@c/BGEventTable'
import BasalsTableV2 from '@c/BasalsTableV2'
import CgmCoreParamTable from '@c/CgmCoreParamTable'
import CgmAgp from '@c/CgmAgp'
import InsulinDeliverySettingTable from '@c/InsulinDeliverySettingTable'
import TableBGMesurement from '@c/TableBGMesurementV3'
import ChartBar from '@c/ChartBar'
import PumpBolusDetailTable from '@c/PumpBolusDetailTableRu'
import { pumpApi } from '@u/api'
import { deepClone } from '@u'
import printMixin from '@mx/print'
import pumpExclusiveMixin from './pumpExclusiveMixin'
import { _legalEventArray } from './bgExclusiveMixinUtil'
import pageTitleMixin from '@mx/pageTitle'
import dayjs from 'dayjs'
import reDrawTrigger from '@mx/reDrawTrigger'
import { _legalDataReadingsInTargetChart, _legalDataDailyListOneDataWithPumpInfoDoNotUsedInComputed } from '@u/reportHelper'
import { _splitBolusDetailDataToTwoPages } from '@u/reportHelperPump'
import { derrorFactory, errorFactory } from '@u/log'
import { getLocaleDateFormat } from '@/util/dateFormat'

const derror = derrorFactory('Pump.vue', false)
const error = errorFactory('Pump.vue', false)

function _pretty(_str, bit = 1) {
  const str = (+_str).toFixed(bit)
  if (/(\.?0+)$/.test(str)) {    
    return str.replace(RegExp.$1, '')
  }
  return str
}

export default {
  name: 'PumpReport',
  components: {
    wtLegend,
    A4Horizontal,
    ChartMultiDailyPump,
    ChartDailyPump,
    PumpBolusDetailTable,
    ChartBar,
    PumpTwoColumnTable,
    Pump4ColumnTable,
    Pump6ColumnTable,
    Pump8ColumnTable,
    BolusCalculatorSettingTable,
    BolusCalculatorSettingTableV3,
    // InsulinUsageStatisticsTable,
    InsulinUsageStatisticsTable1,
    // InsulinUsageStatisticsTable2,
    ChartPie,
    ChartBarV2,
    BGEventTable,
    BasalsTableV2,
    CgmCoreParamTable,
    CgmAgp,
    InsulinDeliverySettingTable,
    TableBGMesurement,
    ChartPumpBasal
  },
  mixins: [printMixin, reDrawTrigger, pageTitleMixin, pumpExclusiveMixin],
  data() {
    return {
      pageTitleMixinNeedTitle: 'Pump Report',
      mods: 255, // (8位)二进制表示为: 11111111;从右到左，各个位分别表示: Multi-day、Daily Graph、Active Basal、Bolus Calculator Setting、Alarm Record、是否显示分割线(pumpOneDay)、Time Change Record、是否显示三餐高亮
      loadingInstance: null,
      allData: [],
      pdaSnList: [],
      dailyList: [],
      setting: {}, // 早餐、午餐、晚餐设置的时间
      NumberOfBgMeasurements: {},
      multiDay: {},
      multiDayBarTruePercents: [],
      multiDayBarTrueCounts: [],
      multiDayCGMBarTruePercents: [],
      multiDayCGMBarTrueCounts: [],
      ajaxLoaded: false,
      agpData: {}
    }
  },
  computed: {
    cgmEventTableBarHasData() {
      const { multiDayCGMBarTrueCounts = [] } = this
      const r = multiDayCGMBarTrueCounts.length && multiDayCGMBarTrueCounts.reduce((cur, prev) => cur + prev, 0)
      return r
    },
    cgmEventTableHighData() {
      const { CgmEventArray = [] } = this.multiDay || {}
      const { highArray = [] } = CgmEventArray
      // const { highArray = [], lowArray = [] } = BgEventArray
      
      const highEventArray = _legalEventArray(highArray)
      // const lowEventArray = _legalEventArray(lowArray)
      return highEventArray
    },
    cgmEventTableLowData() {
      const { CgmEventArray = [] } = this.multiDay || {}
      const { lowArray = [] } = CgmEventArray
      // const { highArray = [], lowArray = [] } = CgmEventArray
      
      // const highEventArray = _legalEventArray(highArray)
      const lowEventArray = _legalEventArray(lowArray)
      return lowEventArray
    },
    bgmEventTableHighData() {
      const { BgEventArray = [] } = this.multiDay || {}
      const { highArray = [] } = BgEventArray
      // const { highArray = [], lowArray = [] } = BgEventArray
      
      const highEventArray = _legalEventArray(highArray)
      // const lowEventArray = _legalEventArray(lowArray)
      return highEventArray
    },
    bgmEventTableLowData() {
      const { BgEventArray = [] } = this.multiDay || {}
      const { lowArray = [] } = BgEventArray
      // const { highArray = [], lowArray = [] } = BgEventArray
      
      // const highEventArray = _legalEventArray(highArray)
      const lowEventArray = _legalEventArray(lowArray)
      return lowEventArray
    },
    pie1arr() {
      let arr = []
      const { insulinChart = {}} = this.multiDay || {}
      
      if (insulinChart && insulinChart.totalBolus !== undefined && insulinChart.totalBasal !== undefined) {
        const _basal = `${insulinChart.totalBasal}`
        const _bolus = `${insulinChart.totalBolus}`
        const total = +_basal + +_bolus
        
        arr = [
          { value: _pretty(_bolus), name: 'Bolus', percent: _pretty(_bolus / total * 100) },
          { value: _pretty(_basal), name: 'Basal Rate', percent: _pretty(_basal / total * 100) }
        ]
      }
      return arr
    },
    
    pie2arr() {
      let arr = []
      const { insulinChart = {}} = this.multiDay || {}
      
      if (insulinChart && insulinChart.totalBolus !== undefined && insulinChart.totalBasal !== undefined && insulinChart.validInsulinDay !== undefined) {
        const _basal = `${insulinChart.totalBasal}`
        const _bolus = `${insulinChart.totalBolus}`
        const total = +_basal + +_bolus
        
        const days = insulinChart.validInsulinDay
        
        if (+days > 0) {
          arr = [
            { value: _pretty(_bolus / days, 3), name: 'Bolus', percent: _pretty(_bolus / total * 100) },
            { value: _pretty(_basal / days, 3), name: 'Basal Rate', percent: _pretty(_basal / total * 100) }
          ] 
        }        
      }
      return arr
    },
    insulinUsageStatisticsObj() {
      const { insulinChart = {}, NumberOfBgMeasurements = {}} = this.multiDay || {}
      const rst = {}
      if (insulinChart && insulinChart.totalBolus !== undefined && insulinChart.totalBasal !== undefined) {
        const _basal = `${insulinChart.totalBasal}`
        const _bolus = `${insulinChart.totalBolus}`
        const days = this.assessmentTimeDaysNum || 1
        
        // uiDataUpdate.multiDayPieStr = insulinMean ? `(${insulinMean})` : ''
        // uiDataUpdate.multiDayPie = [{
        //   value: (_basal / days).toFixed(1),
        //   name: 'Basal Rate'
        // }, {
        //   value: (_bolus / days).toFixed(1),
        //   name: 'Bolus'
        // }]

        Object.assign(rst, insulinChart)
      }

      if (NumberOfBgMeasurements) {
        const { disagreePercent, calculatorBolusPercent } = NumberOfBgMeasurements
        Object.assign(rst, {
          withv: calculatorBolusPercent,
          without: disagreePercent
        })
      }

      return rst
    },
    daysCarbsTotal() {
      const { NumberOfBgMeasurements = {}} = this.multiDay || {}
      const rst = NumberOfBgMeasurements.carbohydrTotal
      return +rst
    },
    carbsValidDays() {
      const { extraData = {}} = this.multiDay || {}
      const { validCarbDay = 0 } = extraData
      return +validCarbDay
    },
    bgMesurementWidth() {
      const { isLongLanguage } = this
      // const rst = isLongLanguage ? 800 : 745
      const rst = isLongLanguage ? (745 + 120) : 745
      // return isLongLanguage ? 725 : 625
      return ~~(rst / 2)
    },
    showMultiDayPumpGraphPage() {
      const bits = +this.mods
      
      return !!(bits & 0b0000001)
    },
    showDailyGraphPumpPage() {
      const bits = +this.mods
      
      return !!(bits & 0b0000010)
    },
    showActiveBasalPage() {
      const bits = +this.mods
      
      return !!(bits & 0b0000100)
    },
    showActiveBasalPage2() {
      const { showActiveBasalPage, basalRateBaseSetting = [] } = this
      return showActiveBasalPage && basalRateBaseSetting && basalRateBaseSetting.length > 3
    },
    showBolusCalculatorPage() {
      const bits = +this.mods
      
      return !!(bits & 0b0001000)
    },
    showAlarmRecordPage() {
      const bits = +this.mods // alarm record的位
      
      return !!(bits & 0b0010000) // 16
    },
    showTimeChangeRecordPage() {
      const bits = +this.mods // time change record的位
      
      return !!(bits & 0b01000000) // 64
    },
    showHorizontalSplitLine() { //
      const bits = +this.mods
      // return false // dev,mock,test
      return !!(bits & 0b0100000)
    },
    showMealTimeHighlight() {
      const bits = +this.mods
      
      return !!(bits & 0b10000000) // 128
    },
    // legalDailyList() {
    //   derror(`computed ,legalDailyList,又触发`)
    //   const { dailyList = [] } = this
    //   const rst = dailyList.filter(_legalDataDailyListOneDataWithPumpInfo)
    //   debugger
    //   return rst
    // },
    barCtnStyle() { // bar的宽度
      const { ds, zoomRatio, isLongLanguage, lfs } = this
      const r = 280 / 1754
      const w = r * ds * zoomRatio * 2
      // const h = 221 / 455 * w
      const rst = {
        marginTop: `${0.5 * lfs}px`,
        marginLeft: `${0.5 * lfs}px`,
        width: `${w + 1}px`
      }
      rst.width = '100%'
      if (isLongLanguage) {
        rst.zoom = 0.9
      }
      // derror(`rst`, rst)
      return rst
    },
    barRectNums() {
      const rst = [54, 70, 180, 250] // 单位是mg/dL时候的值
      const { unit } = this
      
      if (`${unit}`.trim().toLowerCase() !== 'mg/dl') { // mmol/l
        return rst.map(v => +((v / 18).toFixed(1)))
      }
      
      return rst // mg/dL
    },
    style() {
      const rst = {}
      const offset = 0.15 // 每满5页，减少0.1cm; 做了个试验，如果总共6页，那么这个减少的0.1cm不够，从而会最后有一页空白；如果是5页，那么这个减少的0.1cm够用，不会最后多打印一页空白的页面

      const bodyR = this.body21CmRatio
      // const h = (pagesNum * 21 - offset * (Math.ceil(pagesNum / 5)))
      // rst.height = h + 'cm'
      rst.zoom = bodyR
      return rst
    }
  },
  beforeCreate() {
    const $loading = this.$loading({ fullscreen: true })
    
    // const fmt = 'YYYY-MM-DD HH:mm:ssZZ'
    const fmt = 'YYYY-MM-DD'
    const p = Object.assign({}, window._query)
    p.unit = `${p.unit}` === 'mg' ? 1 : 0
    p.timeZone = p.tz
    if (!/\+/.test(p.bgnTime)) {
      p.bgnTime = dayjs(p.bgnTime).format(fmt)      
    }
    if (!/\+/.test(p.endTime)) {
      // p.endTime = dayjs(p.endTime).startOf('day').add(1, 'day').format(fmt)
      p.endTime = dayjs(p.endTime).format(fmt)
    }
    Object.assign(this, {
      _bgnTime: p.bgnTime,
      _endTime: p.endTime
    })
    
    pumpApi.getPumpReport(p).then((res) => {
      const { data, status } = res
      
      $loading.close()
      this.$nextTick(() => {
        this.loadingInstance = $loading
      })
      
      if (`${status}` === '200') {
        const { code, msg } = data
        derror(`接口返回，status: ${status}`)
        if (`${code}` !== '200') {
          // 接口报错
          const tip = msg || `server error`
          this.$message.error(this.$t(`${tip}`))
        } else {
          // 接口成功
          const uiDataUpdate = {} // 最后将这个uiDataUpdate通过Object.assign(this, uiDataUpdate)绑定到this上，从而触发数据变化->ui变化
          const d = data.data || {}
          delete d['allPatientData']
          const pumpAjaxKeys = ['beforeData', 'afterData', 'multiDay', 'allData', 'pumpSn', 'pdaSn', 'dailyList', 'sevenDayReadingsInTarget', 'calculatorList', 'warmMsg', 'basalRateInfoMsg', 'quickPumpTagList', 'setting', 'pdaSetting', 'dataUploadHis', 'agpData']
          const pumpRstAssignToThis = {}
          pumpAjaxKeys.forEach(k => {
            pumpRstAssignToThis[k] = d[k]
            // test,dev,mock
            if (['beforeData', 'afterData'].includes(k)) {              
              if (!d[k]) {
                console.error(`接口${k}返回值为:${d[k]}，不应该，为了逻辑崩溃，我强制设为{}`)
                pumpRstAssignToThis[k] = {}                
              }
            }
            
            if (['pumpSn', 'pdaSn'].includes(k)) {              
              if (!d[k]) {
                console.error(`接口${k}返回值为:${d[k]}，不应该，为了逻辑崩溃，我强制设为[]`)
                pumpRstAssignToThis[k] = []
              }
            }
            // End test,dev,mock
            if (k === 'agpData' && !d[k]) {
              pumpRstAssignToThis[k] = {}
            }
          })
          const { multiDay = {}} = d
          const { cgmReadingsInTargetChart = {}, readingsInTargetChart = {}, NumberOfBgMeasurements = {}} = multiDay
          uiDataUpdate.NumberOfBgMeasurements = NumberOfBgMeasurements
          
          // otherData里头推入"底板更换的数据"，这个数据ajax接口放到NumberOfBgMeasurements下面的reseviorChangeList里头
          const otherData = d.otherData || []
          const { reseviorChangeList = [] } = NumberOfBgMeasurements
          otherData.push(reseviorChangeList)
          
          const dailyList = d.dailyList
          const _pumpLegalDailyList = dailyList ? dailyList.filter(_legalDataDailyListOneDataWithPumpInfoDoNotUsedInComputed) : []
          const pumpLegalDailyList = _splitBolusDetailDataToTwoPages(_pumpLegalDailyList, { lang: this.lang })
          
          const basalRateBaseSetting = d.basalRateBaseSetting || []
          const basalRateBaseSetting_true = (basalRateBaseSetting.sort((first, second) => first.settingIndex - second.settingIndex)).map((obj, i) => { // 根据settingIndex升序并且给上默认的模块名称
            const rst = {
              ...obj
            }
            if (obj && !obj.settingName) {
              rst.settingName = this.$t(`Module`) + `${i + 1}`
            }
            return rst
          })
          
          const { pumpSn, pdaSn } = d
          Object.assign(uiDataUpdate, pumpRstAssignToThis, { pumpSnList: pumpSn?.filter(v => !!v), pdaSnList: pdaSn?.filter(v => !!v), otherData, pumpLegalDailyList, basalRateBaseSetting: basalRateBaseSetting_true })
          
          // bgm readingsInTarget: chart bar
          if (readingsInTargetChart) {
            if (_legalDataReadingsInTargetChart(readingsInTargetChart)) {
              const { veryLow, veryhigh, high, low, target } = readingsInTargetChart
              uiDataUpdate.multiDayBarTruePercents = [+veryLow.percent, +low.percent, +target.percent, +high.percent, +veryhigh.percent]
              uiDataUpdate.multiDayBarTrueCounts = [+veryLow.value, +low.value, +target.value, +high.value, +veryhigh.value]
            }
          }
          
          // cgm readingsInTarget: chart bar
          if (cgmReadingsInTargetChart) {
            if (_legalDataReadingsInTargetChart(cgmReadingsInTargetChart)) {
              const { veryLow, veryhigh, high, low, target } = cgmReadingsInTargetChart
              uiDataUpdate.multiDayCGMBarTruePercents = [+veryLow.percent, +low.percent, +target.percent, +high.percent, +veryhigh.percent]
              uiDataUpdate.multiDayCGMBarTrueCounts = [+veryLow.value, +low.value, +target.value, +high.value, +veryhigh.value]
            }
          }
          
          // 高低血糖
          const patientInfo = d.patientInfo || {}
          const { highLimit, lowLimit, patientName } = patientInfo          
          
          if (patientName) {
            this.$store.dispatch('redraw/updateName', patientName)
          }
          this.$store.dispatch('redraw/updateHighAndLowLimit', {
            high: highLimit,
            low: lowLimit
          })
          
          // 有数据了，触发redraw(以前是以为页面上会有一个切换单位按钮，从而弄了这么一个redraw/notifyReDraw希望能让echarts重新绘图)
          this.$store.dispatch('redraw/notifyReDraw')
          
          // if (`${highLimit}` !== '10' || `${lowLimit}` !== '3.9') {
          //   // 该用户不是默认值的高低血糖值
          //   // 需要触发redraw
          //   // 有需要更新的,通知ui进行重新渲染
          //   this.$store.dispatch('redraw/notifyReDraw')
          // }

          Object.assign(this, uiDataUpdate) // 触发ui变化            
          setTimeout(() => {
            this.ajaxLoaded = true
            console.error(`ajax数据下载完成，希望触发，开始渲染`)
          }, 100)
        }
      }
    })
  },
  created() {
    // 获取显示模块
    this.processMods()
    
    this.processUnitAndLangAndHour(true) // 入参true, 意味者当前是init
  },
  methods: {
    changeFromI18n(change = {}) {
      if (change) {
        const fromNotNull = !['null', 'NULL', 'undefined'].includes(`${change.from}`)
        if (fromNotNull) {
          const tpl = this.$t('Change from %1 to %2')
          const target = tpl.replace('%1', change.from).replace('%2', change.to)
          return target
        } else {
          // 简单粗暴，就直接 change to
          const tpl = this.$t('Change to %1')
          const target = tpl.replace('%1', change.to)
          return target
        }
      } else {
        return ''
      }
    },
    dailyBehaviorHelperGetBarData(data = {}) {
      // derror(`dailyBehaviorHelperGetBarData`)
      const { threeChartData = {}} = data
      const { readingsInTargetChart } = threeChartData
      
      let rst = []
      
      if (readingsInTargetChart) {
        if (_legalDataReadingsInTargetChart(readingsInTargetChart)) {
          const { veryLow, veryhigh, high, low, target } = readingsInTargetChart
          rst = [+veryLow.percent, +low.percent, +target.percent, +high.percent, +veryhigh.percent]
        }
      }
      
      return rst
    },
    dailyBehaviorHelperGetBarCountsData(data = {}) {
      const { threeChartData = {}} = data
      const { readingsInTargetChart } = threeChartData
      
      let rst = []
      
      if (readingsInTargetChart) {
        if (_legalDataReadingsInTargetChart(readingsInTargetChart)) {
          const { veryLow, veryhigh, high, low, target } = readingsInTargetChart
          rst = [+veryLow.value, +low.value, +target.value, +high.value, +veryhigh.value]
        }
      }
      
      return rst
    },
    processUnitAndLangAndHour(justInit = false) {
      const _uiNeedUpdate = {
        unit: false,
        lang: false,
        hour24: false
      }
      
      // step1, 判断语言是否need upate
      const _dl = process.env.VUE_APP_I18N_LOCALE || 'en' // default locale
      let nLocale = this.$route.query.lang || _dl // 切语言
      
      const { locale: oldLocale } = this.$i18n
      
      if (`${oldLocale}` !== `${nLocale}`) {
        _uiNeedUpdate.lang = true
      }
      
      // step2, 判断unit是否更新，默认使用单位是 'mmol/l'
      const _du = 'mmol/L'
      const nU = this.$route.query.unit ? `${this.$route.query.unit}`.trim() : _du
      const { unit: oU } = this
      
      if (`${nU}`.trim().toLowerCase() !== `${oU}`.trim().toLowerCase()) {
        _uiNeedUpdate.unit = true
      }
      
      // step3, 判断是否更新时间制，默认使用24小时制
      const _dHour = 24
      const nHour = this.$route.query.hour ? `${this.$route.query.hour}`.trim() : _dHour
      const { hourFormat: oHour } = this
      
      if (+nHour && +nHour !== +oHour) {
        _uiNeedUpdate.hour24 = true
      }
      
      if (_uiNeedUpdate.lang) { // 切语言的逻辑
        // 切语言; dayjs的语言切换，已经在main.js里头设置了
        if (`${nLocale}`.toLowerCase() === 'polish') {
          error(`语言参数，波兰语要传值pl, 不能传值polish;但我目前是支持polish的`)
          nLocale = 'pl'
        }
        
        this.$store.dispatch('redraw/updateLang', nLocale) // 这个dispatch之后的逻辑需要TBC,tbc,mock,dev
        
        // 手动切$i18n的语言库
        this.$i18n.locale = nLocale
        
        // TBC, tbc, dev: 需要切换dayjs的语言库，这个可以放到dispatch之后的逻辑里头?        
      }
      
      if (_uiNeedUpdate.unit) { // 切unit的逻辑;tbc,TBC
        this.$store.dispatch('redraw/updateUnit', nU)
      }
      
      if (_uiNeedUpdate.hour24) { // 切24小时制的逻辑;tbc,TBC
        this.$store.dispatch('redraw/updateHourformat', nHour)
      }
      
      console.error(`[processUnitAndLangAndHour], justInit: ${justInit}, _uiNeedUpdate: ${JSON.stringify(_uiNeedUpdate)}`)
      
      if (!justInit) {
        if (!Object.keys(_uiNeedUpdate).every(v => !!v === false)) {
          console.error(`[processUnitAndLangAndHour]触发redraw/notifyReDraw,从而让页面上的图表重新绘画`)
          // 有需要更新的,通知ui进行重新渲染
          this.$store.dispatch('redraw/notifyReDraw')
        }     
      }
      
      return _uiNeedUpdate
    },
    processMods() {
      const _dMods = 127
      const mods = this.$route.query.mods ? +`${this.$route.query.mods}` : _dMods
      
      // 具体逻辑(do action)
      this.mods = mods
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
@import '@/styles/variables';  
/*设置默认横向打印*/
@page {
    size: A4 landscape;
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    margin-bottom: 0;
}
.pumpReport-ctn {
    -webkit-print-color-adjust: exact;
    -moz-print-color-adjust: exact;
    color-adjust: exact;
    /* display: flex; */
    /* 上面的display:flex,会影响break-before:page或者类似的功能，从而导致pdf生成的时候会坍塌*/
    /* flex-direction: column; */
    /* height: 83.888cm; // tbc,dev: 要根据实际的页数进行调整。21cm * 4页，再小一点，然后通过overflow:hidden，从而使得第五页(也即是空白页消失) */
}
@media print {
    .pumpReport-ctn {
        overflow: hidden;
        zoom: 1 !important;
    }
}
.line {
    height: 1px;
    background-color: white;
}
.tips {
    @include bBox;
    font-size: 18px;
    font-weight: 500;
    margin-top: 20px;
    line-height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    position: relative;
    /* left: -22px; */
    .border {
        width: 20px;
        height: 40px;
        background: $colorA4PageTitleGreenBg;
        border-radius: 12px 4px 4px 12px;
        margin-right: 10px;
        background-color: $colorA4PageTitleGreenBg;
    }
    .label {
        color: white;
        background-color: $colorA4PageTitleGreenBg;
        border-radius: 5px;
        padding: 0 20px;
    }
}
.alarmRecord-date {
}
.alarmRecord-oneRow {
    @include flexRow(space-around, flex-start);
}
$pl: $sizePaddingTopLegend;

.legend.chartDailyPumpLegend {
    /* margin-left: $pl * 2; */
    zoom: 0.85;
    margin-top: 4px;
    &.legend--row2 {
        margin-top: $pl;
        margin-bottom: $pl + 4px;
    }
    &.twoParts {
        @include flexRow(space-between, center);
        .legendsPart--title {
            zoom: calc(13 / 22);
            font-size: 16px;
            color: #485465;
            font-weight: 500;
            display: inline-block;
        }
        zoom: 0.85;
    }
    ::v-deep .wtLegend-ctn {
        zoom: calc(13 / 22);
        margin-left: $pl;
        &:first-child {
            margin-left: 0;
        }
    }
    ::v-deep > .wtLegend-ctn {
        /* zoom: calc(16 / 22); */
        margin-left: $pl;
        &:first-child {
            margin-left: 0;
        }
    }
}
.basalRateBaseCtn {
    .basalRateBaseCtn-oneBase--title {
        margin-top: 10px;
        &:first-child {
            margin-top: 10px;
        }
        height: 25px;
        font-size: 18px;
        /* font-family: PingFangSC-Medium, PingFang SC; */
        font-weight: 500;
        color: #050505;
        
        margin-bottom: 10px;
        > * {
            vertical-align: top;            
        }
        .basalRateBaseCtn-oneBaseTitle--main {
            font-weight: bold;
            display: inline-block;
            max-width: 320px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
        .basalRateBaseCtn-oneBaseTitle--subtitle {
            margin-left: 0.8rem;
        }
    }
}

/* .eventTablesCtn { */
/*     margin-top: 40px; */
/*     width: (755 / 1754) * 100%; */
/*     @include flexColumn(flex-start, center); */
/* } */
.eventTablesCtn-row {
    width: 100%;
    width: (755 / 1754) * 100%;
    @include bBox;
    @include flexRow(space-between, center);
    &:last-child {
        margin-top: 60px;
        margin-top: 10px;
        @include flexRow(space-between, flex-start);
    }
    &.eventTablesCtn-row--w100 {
        width: 100%;
    }
    > .eventTablesCtnRow-tables {
        > * {
            margin-top: 20px;
            &:first-child {
                margin-top: 0;
            }
        }
    }
}
.insulinUsageChartCtn {
    margin-top: 36px;
    @include flexRow(space-between, baseline);
}
</style>
